import type React from "react";
import { IconButton } from "@similarweb/ui-components";
import type { IconName } from "@similarweb/icons";
import {
    Wrapper,
    IconButtonWrapper,
    Text,
} from "app/pages/digital-suite/home-page/components/CustomAssets/Assets/GenericTemplate/styledComponents";

interface IGenericAssetTemplateProps {
    text: string;
    iconName: IconName;
    onClick: () => void;
}

export const GenericAssetTemplate: React.FC<IGenericAssetTemplateProps> = ({ onClick, iconName, text }) => {
    return (
        <Wrapper
            data-automation={"generic-template"}
            onClick={onClick}
        >
            <IconButtonWrapper>
                <IconButton
                    iconName={iconName}
                    iconSize={"xs"}
                />
            </IconButtonWrapper>
            <Text>{text}</Text>
        </Wrapper>
    );
};
